import cookie from 'cookie-utils-js';
import { sleep, getStorageData } from '@/utils/util';
import { authByTicket, getUserInfo } from '@/api/user';

const resetState = {
	isLogin: false,
	userName: '',
	userId: '',
	photo: '',
	userToken: '',
	balance: 0
};

const actions = {
	async auth({ commit, state, rootState, dispatch }, payload) {
		const ticket = payload.ticket;
		const isWebview = payload.webview;
		let redirectURL = payload.redirectURL || `https://cozytaps.com/desktop/shop`;

		redirectURL = decodeURIComponent(redirectURL);

		if (ticket) {
			try {
				const res = await authByTicket({
					ticket: decodeURIComponent(ticket)
				});

				localStorage.setItem('user_token', res.data.token);
				localStorage.setItem('appid', res.data.appid);
				commit('UPDATE_USER_TOKEN', {
					userToken: res.data.token
				});
				await dispatch('updateAppBaseInfo', {
					appid: res.data.appid,
					redirectURL
				});
				await Promise.all([
					dispatch('updateUserInfo'),
				]);
				return;
			}
			catch(err) {
				console.log(err);
			}
		}

		const userToken = await getStorageData('user_token');
		const appid = await getStorageData('appid');

		if (userToken && appid) {
			commit('UPDATE_USER_TOKEN', {
				userToken: userToken
			});
			await dispatch('updateAppBaseInfo', {
				appid: appid,
				redirectURL
			});
			await Promise.all([
				dispatch('updateUserInfo'),
			]);
			return;
		}

		localStorage.setItem('user_token', '');
		localStorage.setItem('appid', '');
		await Promise.all([
			dispatch('resetUserState'),
			dispatch('resetAppState')
		]);
	},

	// token可能失效
	async updateUserInfo({ commit, state, rootState, dispatch }, payload) {
		try {
			const res = await getUserInfo({
				token: state.userToken,
				appid: rootState.app.appid
			});

			commit('UPDATE_USER_INFO', {
				isLogin: true,
				userName: res.data.nickname,
				photo: res.data.avatar,
				userId: res.data.fake_id,
				balance: res.data.balance
			});
			return;
		}
		catch(err) {
			console.log(err);
		}

		await dispatch('resetUserState');
	},

	async loginout({ commit, state, rootState }, payload) {
		localStorage.setItem('user_token', '');
		localStorage.setItem('appid', '');
		commit('UPDATE_USER_INFO', {
			...resetState
		});
	},

	async resetUserState({ commit, state, rootState }, payload) {
		commit('UPDATE_USER_INFO', {
			...resetState
		});
	},

	async updateUserToken({ commit, state, rootState }, payload) {
		commit('UPDATE_USER_TOKEN', {
			userToken: payload.userToken || ''
		});
	},
}

export default actions;
